import { Reveal, Eyebrow } from "./Reveal";

const BENEFITS = [
  ["22g", "protein per bag", "bg-[#BDE3FA]"],
  ["75%", "less sugar vs leading candy equivalent", "bg-[#FFD9DA]"],
  ["7g", "fibre in every bag", "bg-white"],
  ["150", "calories. That's it.", "bg-[#FFE7B8]"],
];

export const HomeIntro = () => (
  <section data-testid="home-intro-section" className="py-20 lg:py-28">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-6 mb-12">
        <Reveal className="lg:col-span-7">
          <Eyebrow className="text-[#FF5A5F] mb-4">Why people love them</Eyebrow>
          <h2 className="font-display text-4xl sm:text-6xl leading-[0.95]">Tastes like the candy aisle. Reads like a snack you can feel good about.</h2>
        </Reveal>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {BENEFITS.map(([big, label, bg], i) => (
          <Reveal key={big} delay={i * 0.07} data-testid={`benefit-card-${i}`} className={`${bg} rounded-[28px] p-5 sm:p-8 min-h-[170px] sm:min-h-[220px] flex flex-col justify-between border border-[#1B1530]/10`}>
            <span className="font-display text-6xl sm:text-8xl leading-none">{big}</span>
            <span className="font-semibold text-sm sm:text-base">{label}</span>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
